<template>
    <div class="pad20">
        <div class="vx-row m-0 main-list-panel">
            
            <div class="vx-col md:w-1/3 w-full p-0" v-if="canRenderField('benfApplyAdjustStatus',questionnaireDetails, false, 'sponsorInfo.affidavitInfo' )">
                <div class="main-list">
                    <p>
                        Is beneficiary is applying for adjustment of status based on your application?
                        <span>{{ checkProperty(petition, 'benfApplyAdjustStatus') | booleanFormat}}</span>
                    </p>
                </div>
            </div>
            <template v-if="checkProperty(petition, 'benfApplyAdjustStatus') ">
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition, 'currentAnnualSalary')">
                <div class="main-list">
                    <p>
                        Current annual salary
                        <span>{{ checkProperty(petition, 'currentAnnualSalary') | formatprice}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition, 'nameOfEmployer')">
                <div class="main-list">
                    <p>
                        Name of the employer
                        <span>{{ checkProperty(petition, 'nameOfEmployer') }}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition, 'currentPosition')">
                <div class="main-list">
                    <p>
                        Current Position
                        <span>{{ checkProperty(petition, 'currentPosition') }}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition, 'depositsInBankUSA')">
                <div class="main-list">
                    <p>
                        Deposits in Bank
                        <span>{{ checkProperty(petition, 'depositsInBankUSA') | formatprice }}</span>
                    </p>
                </div>
            </div>
            <template v-if="checkProperty(petition,'benfAdjustmentDocument')">
                <vs-col class="padl0 padr0" v-if="checkProperty(petition,'benfAdjustmentDocument','length')>0" >
                <documentsView @download_or_view="download_or_view" :type="'benfAdjustmentDocument'"  :documentsList="petition['benfAdjustmentDocument']" :petitionDetails="petition" />
                </vs-col>
            </template>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition, 'reasonableValPersonalProperty')">
                <div class="main-list">
                    <p>
                        Reasonable value of personal property
                        <span>{{ checkProperty(petition, 'reasonableValPersonalProperty') }}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="false && checkProperty(petition, 'haveMarketValInStocksAndBonds')">
                <div class="main-list">
                    <p>
                        DO you have bonds and stocks
                        <span>{{ checkProperty(petition, 'haveMarketValInStocksAndBonds') | booleanFormat}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition, 'marketValInStocksAndBonds')">
                <div class="main-list">
                    <p>
                        Market value of bonds and stocks
                        <span>{{ checkProperty(petition, 'marketValInStocksAndBonds')}}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition, 'sumOfLifeInsurance')">
                <div class="main-list">
                    <p>
                        Sum of Life Insurance
                        <span>{{ checkProperty(petition, 'sumOfLifeInsurance') }}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition, 'cashSurrValOfLifeInsurance')">
                <div class="main-list">
                    <p>
                        Cash surrender value of Life Insurance
                        <span>{{ checkProperty(petition, 'cashSurrValOfLifeInsurance') }}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="false && checkProperty(petition, 'haveValOfRealEstate')">
                <div class="main-list">
                    <p>
                        DO you owned Real Estate
                        <span>{{ checkProperty(petition, 'haveValOfRealEstate') | booleanFormat }}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if=" checkProperty(petition, 'valOfRealEstate')">
                <div class="main-list">
                    <p>
                        Value of Real Estate
                        <span>{{ checkProperty(petition, 'valOfRealEstate') }}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition, 'amountOfMortgageProperty')">
                <div class="main-list">
                    <p>
                        Amount of Morgage on the property
                        <span>{{ checkProperty(petition, 'amountOfMortgageProperty') }}</span>
                    </p>
                </div>
            </div>
            <div class="vx-col md:w-1/3 w-full p-0" v-if="checkProperty(petition, 'addressPropertyIsLocate')">
                <div class="main-list">
                    <p>
                        Address where the real property is located
                        <span>{{ checkProperty(petition, 'addressPropertyIsLocate') }}</span>
                    </p>
                </div>
            </div>
            </template>
        </div>
</div>
</template>
    
<script>
import documentsView from "@/views/common/documentsView.vue";
import _ from "lodash";
export default {
    components: {
        documentsView
    },
    data: () => ({
        visastatuses: [],
        docPrivew: false,
    }),
    props: {
        questionnaireDetails:{
            type: Array,
            default: []
        },
        petition: {
            type: Object,
            default: null
        },

    },
    computed: {

    },
    methods: {
        download_or_view(value) {
            this.$emit('download_or_view' ,value);
        },
    },
    mounted() {

    }
};
</script>
    